import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

export interface AttachmentCardProps {
  logoUrl?: string;
  heading?: string;
  columns: React.ReactNodeArray;
  emptyStateCopy?: string;
  buttons?: React.ReactNode;
  className?: string;
  bgColor?: string;
  fontColor?: string;
  fontFamily?: string;
}

export default function AttachmentCard({
  logoUrl,
  columns,
  buttons,
  className = '',
  emptyStateCopy,
  bgColor,
  fontColor,
  fontFamily,
}: AttachmentCardProps) {
  const isEmpty = columns.length === 0;
  const { t } = useTranslation();
  return (
    <div
      className={cx(
        'rounded-none md:rounded-3xl max-w-[818px] min-h-[449px] m-auto w-full h-full md:mt-auto md:h-fit md:pt-0 relative md:bg-transprent',
        className
      )}
      style={{ backgroundColor: bgColor, fontFamily}}
    >
      <div className='overflow-auto p-8 border rounded-none md:rounded-3xl text-center justify-center text-xs h-full md:h-fit min-h-[449px] flex flex-col'>
        <div className='md:!hidden mb-5 w-full flex justify-center'>
          {logoUrl && (
            <img
              src={logoUrl}
              width={125}
              height={25}
              className='object-contain'
            />
          )}
        </div>
        <div className='flex flex-col flex-1 mb-5 pr-4 mr-[-10px] overflow-y-auto scrollbar-thin scrollbar-track-neutral-200 scrollbar-track-rounded-full scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full'>
          <span
            className='text-xl font-medium'
              style={{ color: fontColor}}
            >
            {!isEmpty && t('testimonial:additionalInfo.form.header')}
          </span>

          <div className='my-auto'>
            {isEmpty && emptyStateCopy && (
              <h2
                className='text-center text-xl'
                style={{ color: fontColor}}
              >
                {emptyStateCopy}
              </h2>
            )}
            <div
              className={cx('flex flex-col sm:flex-row w-full mt-5', {
                'justify-between': columns.length === 2,
                'justify-center': columns.length < 2,
              })}
            >
              {columns.map((column, index) => (
                <div
                  className='flex flex-col w-full sm:w-[336px] sm:justify-center'
                  key={index}
                >
                  {column}
                </div>
              ))}
            </div>
          </div>
        </div>
        {buttons}
      </div>
    </div>
  );
}
